import { prefixPhoneNumber } from '~src/utils/prefixPhoneNumber';

export const createPhoneUrl = (s) => {
  return `tel:${prefixPhoneNumber(s)}`;
};
